import { SectionLabel, Reveal } from '../Section';
import PhoneFrame from '../PhoneFrame';

const SHOTS = [
  { src: '/screenshots/arena.webp', alt: 'KROY app — The Arena tournament list' },
  { src: '/screenshots/home.webp', alt: 'KROY app — Home with featured tournament' },
  { src: '/screenshots/wallet.webp', alt: 'KROY app — Tournament Wallet with Winning Vault' },
];

export default function Screenshots() {
  return (
    <section className="py-20 sm:py-28 bg-[#0a0a0a] overflow-hidden" data-testid="screenshots-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center flex flex-col items-center">
          <SectionLabel testid="screenshots-label">The Arena in Your Hands</SectionLabel>
          <Reveal>
            <h2 className="mt-5 font-display text-white text-3xl sm:text-5xl max-w-2xl">
              Every match. Every win. <span className="text-[#e8173a]">In your pocket.</span>
            </h2>
          </Reveal>
        </div>
        <div className="mt-16 grid grid-cols-3 gap-4 sm:gap-8 max-w-4xl mx-auto items-center">
          <PhoneFrame src={SHOTS[0].src} alt={SHOTS[0].alt} delay={0.1} />
          <PhoneFrame src={SHOTS[1].src} alt={SHOTS[1].alt} center delay={0} />
          <PhoneFrame src={SHOTS[2].src} alt={SHOTS[2].alt} delay={0.2} />
        </div>
      </div>
    </section>
  );
}
